import { DataAccess } from "../dataaccess/data.access";
import { EventService } from "./event.service";

export class StandoutClassroomService {
    private static getRedirectUrl(subPath: string) {
        let url = DataAccess.getUrl(`/redirect/app?app=soc&redirect=${encodeURIComponent(subPath)}`);
        if (window.location.hostname === "localhost") {
            url += "&fullToken=true";
        }
        return url;
    }

    public static getChatLink() {
        return StandoutClassroomService.getRedirectUrl(`/init/chat/app`);
    }

    public static async getEventChatLink(eventId: number) {
        let channelName = await EventService.getEventNameOrTitle(eventId);
        return StandoutClassroomService.getRedirectUrl(
            `/init/chat/${eventId}/app?title=${encodeURIComponent(channelName)}`,
        );
    }
}
